// ProductPhoto.js

import React, { Component } from 'react';
import { Button, Form, Table, Container, Row, Col, ButtonToolbar, Overlay, Popover } from 'react-bootstrap';
import Config from '../Config';
import ScrollArea from 'react-scrollbar';
import Modal from 'react-awesome-modal';
import ProductImageMapDetail from './ProductImageMapDetail';

class RowItem extends Component {
    static defaultProps = {
        key: null,
        item: null,
        enable: false,
        onPress: () => { },
        onChange: () => { },
    }
    constructor(props) {
        super(props);
        this.state = {
            item: this.props.item,
            enable: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        // console.log("componentWillReceiveProps: " + JSON.stringify(nextProps));
        this.setState({
            item: nextProps.item
        });
    }

    handleRowClick = () => {
        this.props.onPress(this.props.item);
        event.preventDefault();
    }

    render() {
        return (
            <tr onClick={this.handleRowClick} style={ this.props.enable ? {'background-color': '#ffff00'} : {} } >
                <td>{this.props.item.ID}</td>
                <td>{this.props.item.IMAGENAME}</td>
                <td>{this.props.item.PRINTYN}</td>
                <td>{this.props.item.WIDTH}</td>
                <td>{this.props.item.HEIGHT}</td>
            </tr>
        );
    }
};

export default class ProductImageMap extends Component {
    static defaultProps = {
        item: null,
        images: null,
        enable: false,
        onPress: () => { },
    }
    constructor(props) {
        super(props);
        this.timer = null;
        this.locals = ["Kor", "Eng", "Jpn", "Chn"];
        this.emptyItem = {
            ID: 0,
            PCODE: "0000",
            LCODE: "",
            TITLE: "",
            RTSEC: "",
            THUMBNAIL: ""
        }
        this.state = {
            timages: [],
            rowlist: [],
            answervisible: false,
            enable: true,
            item: this.props.item,
            images: this.props.images,
            language: this.locals[0],
            details: [],
            loading: false,
            S3ButtonText: 'S3에서 가져오기',
            s3ButtonDisabled: false,
            imageMapDetailvisible: false,
            mapitem: this.props.item
        };
        this.selectID = -1;
    }

    componentWillReceiveProps(nextProps) {
        // console.log("componentWillReceiveProps: " + JSON.stringify(nextProps));
        this.setState({ item: nextProps.item, images: nextProps.images });
        this.refreshGetInfo();
        this.selectID = -1;
    }

    refreshGetInfo() {
        if (this.timer)
            clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.handleGetInfo(null);
        }, 500);
    }

    handleClose() {
        this.setState({ imageMapDetailvisible: false });
    }

    handleGetInfo(event) {
        Config.fetchData('productimagemaps', {
            PCODE: this.state.item.PCODE
        }, (result, count) => {
            console.log('productimagemaps=', result);
            this.setState({ details: result }, () => {
                this.handleChangeDetail();
            })
        }, true);
    }

    handleChangeDetail() {
        this.setState({ rowlist: this.state.details });
    }


    handleSubmit(event) {
        var result = confirm("저장 하시겠습니까?");
        if (result) {

            var arrData = [];
            var list = this.state.rowlist;
            for (var i = 0; i < list.length; ++i) {
                arrData.push([list[i].PCODE, list[i].IMAGENAME, list[i].PRINTYN, list[i].WIDTH, list[i].HEIGHT , list[i].MAPHTML , list[i].MAPJSON  ])
            }

            Config.fetchData('insproductimagemaps', {
                PCODE: this.state.item.PCODE,
                DATA: arrData
            }, (result, count) => {
                console.log('insproductimagemaps=', count);
                this.refreshGetInfo();
            }, true);
        }
        event.preventDefault();
    }

    handleRemove(event) {
        var result = confirm("삭제 하시겠습니까?");
        if (result) {
            Config.fetchData('delproductimagemaps', {
                PCODE: this.state.item.PCODE
            }, (result, count) => {
                console.log('delproductimagemaps=', count);
                this.refreshGetInfo();
            }, true);
        }
        event.preventDefault();
    }

    handleGetFromS3(event) {
        this.setState({ S3ButtonText: "파일 가져오는 중...", s3ButtonDisabled: true });

        Config.fetchData('getproductfiles', {
            PCODE: this.state.item.PCODE,
            FOLDER: '/imageMap'
        }, (result, count) => {
            console.log('getproductphoto=', result);
            var imagelist = [];
            for (var i = 0; i < result.length; ++i) {
                var item = { ...this.emptyItem };
                item.ID = i;
                item.PCODE = this.state.item.PCODE;
                item.IMAGENAME = result[i].name;
                item.PRINTYN = result[i].PRINTYN;
                item.WIDTH = result[i].WIDTH;
                item.HEIGHT = result[i].HEIGHT;
                item.MAPHTML = '';
                item.MAPJSON = '';
                imagelist.push(item);
            }
            this.setState({ rowlist: imagelist });
            this.setState({ S3ButtonText: "S3에서 가져오기", s3ButtonDisabled: false });
        }, true);
        event.preventDefault();
    }


    handleRowClick = (rowitem) => {
        console.log(rowitem);
        this.selectID = rowitem.ID;
        this.setState({ mapitem: rowitem });
        // this.setState({ imageMapDetailvisible: true });
    }

    handleOnChange = (rowitem) => {
        console.log(rowitem);
        this.setState({ mapitem: rowitem });
        this.setState({ imageMapDetailvisible: false });
    }

    stringToHTML = (strHTML) => {
        var parser = new DOMParser();
        var docHTML = parser.parseFromString(strHTML, 'text/html');
        return docHTML
    }

    imageMapHTMLtoJson = (strHTML) => {
        var document = this.stringToHTML(strHTML);
        console.log('images=', document.images );
        var json = {};
        for(var img of document.images)
        {
            console.log('img=', img.src , img.width , img.height);
            json.src = img.src;
            json.src = json.src.toLowerCase().lastIndexOf('.jpg') > 0 ? json.src.substr( json.src.lastIndexOf('/') + 1 ) : json.src;
            json.width = img.width;
            json.height = img.height;
        }
        var areas = document.getElementsByTagName("AREA");
        console.log('areas=', areas);
        json.areas = [];
        for(var area of areas)
        {
            console.log('AREA=', area.shape , area.coords , area.alt ,  area.href);
            var jpgsrc = area.href;
            jpgsrc = area.href.toLowerCase().lastIndexOf('.jpg') > 0 ? area.href.substr( area.href.lastIndexOf('/') + 1 ) : jpgsrc;
            json.areas.push( { 'shape'  :  area.shape  , 'coords' : area.coords , 'alt' : area.alt , 'href' :  jpgsrc } );
        }
        console.log('json=' , json);
        return json;
    }

    handleChangeHTML(event) {
        var item = this.state.mapitem;
        item.MAPHTML = event.target.value;
        this.setState({ mapitem: item });
        var jsonmap = this.imageMapHTMLtoJson(item.MAPHTML) ;
        var jsonstr = JSON.stringify(jsonmap, null, 2 );

        var item = this.state.mapitem;
        item.MAPJSON = jsonstr;
        item.width = jsonmap.width ? jsonmap.width : item.width;
        this.setState({ mapitem: item });
    }

    handleChangeJSON(event) {
        // var item = this.state.mapitem;
        // item.MAPJSON = event.target.value;
        // this.setState({ mapitem: item });
    }

    render() {
        let scrollbarStyles = { borderRadius: 5 };
        return (
            <div className="box" >
                <Modal visible={this.state.imageMapDetailvisible} height="90%" width="90%" effect="fadeInUp" onreset={() => { this.componentDidMount() }} onClickAway={() => this.handleClose()}>
                    <div style={{ margin: 20 }}>
                        <table>
                            <tr>
                                <td>
                                    <div className="row" style={{ margin: 16 }}>
                                        <Button variant="primary" onClick={this.handleClose.bind(this)}>X</Button>
                                    </div>
                                </td>
                                <td>
                                    <h2 className="box-title">이미지맵 설정 및 보기</h2>
                                </td>
                            </tr>
                        </table>
                        <ProductImageMapDetail item={this.state.mapitem} enable={this.state.imageMapDetailvisible} onChange={this.handleOnChange.bind(this)} />
                    </div>
                </Modal>
                <div className="row" style={{ margin: 10 }}>
                    <div className="col-md-12">
                        <Button disabled={this.state.s3ButtonDisabled} variant="primary" onClick={this.handleSubmit.bind(this)}>저장</Button>
                        <Button disabled={this.state.s3ButtonDisabled} variant="primary" onClick={this.handleGetFromS3.bind(this)}>{this.state.S3ButtonText}</Button>
                        <Button disabled={this.state.s3ButtonDisabled} variant="primary" onClick={this.handleRemove.bind(this)}>삭제</Button>
                    </div>
                </div>
                <div className="row" style={{ margin: 10 }}>
                    <hr />
                </div>
                <div className="row" style={{ margin: 10 }}>
                    <ScrollArea style={{ width: '100%', height: 300 }}
                        className="area"
                        contentClassName="content"
                        verticalScrollbarStyle={scrollbarStyles}
                        verticalContainerStyle={scrollbarStyles}
                        horizontalScrollbarStyle={scrollbarStyles}
                        horizontalContainerStyle={scrollbarStyles}
                        smoothScrolling={true}
                        minScrollSize={5}
                        onScroll={this.handleScroll}
                    >
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <td>#</td>
                                    <td>파일명</td>
                                    <td>인화여부</td>
                                    <td>넓이</td>
                                    <td>높이</td>
                                </tr>
                            </thead>
                            <tbody>

                                {this.state.rowlist.map((item, index) =>
                                    <RowItem key={index} item={item} enable={this.selectID == item.ID ? true : false } onPress={this.handleRowClick.bind(this)} />
                                )}

                            </tbody>
                        </Table>
                    </ScrollArea>
                </div>
                <div className="row" style={{ margin: 10 }}>
                    <hr />
                </div>
                <div className="row" style={{  margin: 10 }}>
                    <div className="col-md-12">
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <Form.Label>내용(원본)</Form.Label>
                            <Form.Control as="textarea" rows="10" value={this.state.mapitem.MAPHTML} onChange={this.handleChangeHTML.bind(this)}/>
                        </Form.Group>
                    </div>
                </div>
                <div className="row" style={{  margin: 10 }}>
                    <div className="col-md-12">
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <Form.Label>내용(자동변환)</Form.Label>
                            <Form.Control as="textarea" rows="10" value={this.state.mapitem.MAPJSON} onChange={this.handleChangeJSON.bind(this)}/>
                        </Form.Group>
                    </div>
                </div>

            </div>

        );
    }
};





// WEBPACK FOOTER //
// src/components/ProductImageMap.js